import { INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS } from '@/api/rest/resources/types/IndicatorProduct';
import { Logger } from '@/lib/logs/logger';

import { resolveThemeColor } from './resolveThemeColor';

export type StatusStyle = {
  color: string;
  backgroundColor: string;
};

const exhaustivenessCheck = (status: never): StatusStyle => {
  Logger.error(`No color defined for indicator product subscription configuration status "${status}"`);
  return { color: resolveThemeColor('transparent'), backgroundColor: resolveThemeColor('transparent') };
};

export const getStyleForIPConfigStatus = (
  status: (typeof INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS)[keyof typeof INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS],
): StatusStyle => {
  switch (status) {
    case INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.APPROVED:
      return { backgroundColor: resolveThemeColor('success-light'), color: resolveThemeColor('success-dark') };
    case INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.VALIDATED:
      return { backgroundColor: resolveThemeColor('secondary-50'), color: resolveThemeColor('success-dark') };
    case INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.REJECTED:
      return { color: resolveThemeColor('error-dark'), backgroundColor: resolveThemeColor('error-light') };
    case INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.WAITING:
      return { color: resolveThemeColor('warning-dark'), backgroundColor: resolveThemeColor('warning-light') };
    case INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.ERROR:
      return { color: resolveThemeColor('error'), backgroundColor: resolveThemeColor('error-light') };
    default:
      return exhaustivenessCheck(status);
  }
};
